
import axios from "axios";


let url = window.location.href.includes('dev') ? 'https://usermanagement-backend-dev-ca.proudground-2e220f19.westus2.azurecontainerapps.io/api/v1/' : 'https://news3sportal-backend-prod-ca.ashycoast-a791d466.westus2.azurecontainerapps.io'
export const client = axios.create({
  baseURL: url
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);

let portalUrl = window.location.href.includes('dev') ? 'https://news3sportal-bakend-dev-ca.gentleriver-e82bc4ae.eastus2.azurecontainerapps.io/api/v1/' : 'https://news3sportal-backend-prod-ca.ashycoast-a791d466.westus2.azurecontainerapps.io'

export const portalClient = axios.create({
  baseURL: portalUrl
});

portalClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);








